import React from 'react';
import { OFFER_ANCHOR } from '../data/content';
interface CTAButtonProps {
  children: React.ReactNode;
  /** Defaults to the purchase section. */
  href?: string;
  tone?: 'navy' | 'mustard' | 'terracotta';
  subLabel?: string;
}
const tones: Record<'navy' | 'mustard' | 'terracotta', string> = {
  navy: 'bg-navy text-white border-navy-deep hover:bg-navy-deep',
  mustard: 'bg-mustard text-navy border-[#9c7430] hover:bg-[#b4862f]',
  terracotta: 'bg-terracotta text-white border-[#96574c] hover:bg-[#a46256]'
};
export function CTAButton({
  children,
  href = OFFER_ANCHOR,
  tone = 'navy',
  subLabel
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div data-id="element-35" data-mp="38m61ge5z2n0y">
      <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`block w-full rounded-md border-b-4 px-4 py-3 text-center font-body text-sm font-extrabold uppercase leading-tight tracking-wide transition-colors duration-150 ease-out active:translate-y-0.5 active:border-b-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy sm:text-base ${tones[tone]}`} data-id="element-36" data-mp="38mfts8ehp69t">
        {children}
      </a>
      {subLabel && <p className="mt-1.5 text-center text-[11px] font-semibold uppercase tracking-wide text-graphite/70" data-id="element-37" data-mp="1w79kpf8vuvo4">
          {subLabel}
        </p>}
    </div>;
}